import { render, staticRenderFns } from "./ScrollIndicator.vue?vue&type=template&id=7ae97c1e&scoped=true&lang=pug&"
import script from "./ScrollIndicator.vue?vue&type=script&lang=js&"
export * from "./ScrollIndicator.vue?vue&type=script&lang=js&"
import style0 from "./ScrollIndicator.vue?vue&type=style&index=0&id=7ae97c1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae97c1e",
  null
  
)

export default component.exports